export default __webpack_public_path__ + "static/media/personal.3620fa27.png";